import { render, staticRenderFns } from "./AuditPendenciesValueMoreForm.vue?vue&type=template&id=b351a7ea&scoped=true"
import script from "./AuditPendenciesValueMoreForm.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesValueMoreForm.vue?vue&type=script&lang=js"
import style0 from "./AuditPendenciesValueMoreForm.vue?vue&type=style&index=0&id=b351a7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b351a7ea",
  null
  
)

export default component.exports